



























































































import { Component, Vue } from "vue-property-decorator";
import { ConsentsAPI } from "@/api/consents/consents-api";

import StandartModal from "@/components/app/standart-modal.vue";
import StandartDraggableAlert from "@/components/app/shared/alerts/standart-draggable-alert.vue";
import draggable from "vuedraggable";

import ConsentsCard from "./consents/consents-card.vue";
import ConsentsEditModal from "./consents/consents-edit-modal.vue";

import type { IConsents } from "@/@types/filoxenia-config/consents";

@Component({
  components: {
    StandartModal,
    StAlert: StandartDraggableAlert,
    ConsentsCard,
    ConsentsEditModal,
    draggable,
  },
})
class ConsentsConfigSettings extends Vue {
  enabled = true;
  dragging = false;
  recycle = false;
  loading = true;

  consents: IConsents[] = [];
  deleted_consents: IConsents[] = [];
  edit_item: IConsents | null = null;

  start(): void {
    this.getConsents();
  }

  isClean(): void {
    this.edit_item = null;
    this.recycle = false;
  }

  openAdd(): void {
    this.edit_item = null;
    this.$nextTick(() => this.$bvModal.show("consents-config-edit"));
  }

  mustEdit(id: string): void {
    const item = this.consents.find((el) => el._id === id);
    this.edit_item = item ? item : null;
    this.$nextTick(() => this.$bvModal.show("consents-config-edit"));
  }

  async toggleRecycle(): Promise<void> {
    this.recycle = !this.recycle;
    if (this.recycle) await this.getDeletedConsents();
  }

  async getConsents(): Promise<void> {
    try {
      this.loading = true;
      const res = await ConsentsAPI.getAll({
        deleted: { value: false },
      });
      if (res.status === 200) this.consents = res.data;
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    } finally {
      this.loading = false;
    }
  }

  async getDeletedConsents(): Promise<void> {
    try {
      const res = await ConsentsAPI.getAll({
        deleted: { value: true },
      });
      if (res.status === 200) this.deleted_consents = res.data;
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async saveConsent(data: Partial<IConsents>): Promise<void> {
    if (!data) return;
    try {
      if (this.edit_item && this.edit_item._id) {
        await this.updateConsentById(this.edit_item._id, data);
      } else {
        const res = await ConsentsAPI.add(data);
        if (res.status === 200) this.getConsents();
      }
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.200")),
      });
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async updateConsentById(id: string, data: Partial<IConsents>): Promise<void> {
    if (!id) return;
    try {
      const res = await ConsentsAPI.updateById(id, data);
      if (res.status === 200) {
        const i = this.consents.findIndex((el) => el._id === id);
        if (i < 0) this.getConsents();
        else this.$set(this.consents, i, res.data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async saveOrder(): Promise<void> {
    this.dragging = false;
    try {
      await Promise.all(
        this.consents.map((item, i) =>
          ConsentsAPI.updateById(item._id, { sort_order: i })
        )
      );
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.200")),
      });
    } catch (error) {
      console.error(error);
    }
  }

  async confirmDelete(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("consents.confirm.delete")),
        {
          title: String(this.$i18n.t("main.confirms.delete")),
          okVariant: "danger",
        }
      );
      if (result === true) await this.deleteConsent(id);
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async deleteConsent(id: string): Promise<void> {
    if (!id) return;
    try {
      const res = await ConsentsAPI.deleteById(id);
      if (res.status === 200) {
        const i = this.consents.findIndex((el) => el._id === id);
        if (i >= 0) this.consents.splice(i, 1);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async confirmRestore(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("consents.confirm.restore")),
        {
          title: String(this.$i18n.t("buttons.restore")),
        }
      );
      if (result === true) await this.restoreConsent(id);
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async restoreConsent(id: string): Promise<void> {
    if (!id) return;
    try {
      const res = await ConsentsAPI.restoreById(id);
      if (res.status === 200) {
        const i = this.deleted_consents.findIndex((el) => el._id === id);
        if (i >= 0) this.deleted_consents.splice(i, 1);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async confirmForceDelete(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("consents.confirm.force-delete")),
        {
          title: String(this.$i18n.t("buttons.force_delete")),
          okVariant: "danger",
        }
      );
      if (result === true) await this.forceDeleteConsent(id);
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async forceDeleteConsent(id: string): Promise<void> {
    if (!id) return;
    try {
      const res = await ConsentsAPI.forceDeleteById(id);
      if (res.status === 200) {
        const i = this.deleted_consents.findIndex((el) => el._id === id);
        if (i >= 0) this.deleted_consents.splice(i, 1);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
    } catch (error) {
      console.error(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }
}
export default ConsentsConfigSettings;
